import React, { Component } from 'react'
import classnames from 'classnames'
import { getDisplayableIdentities, setAccessToken, clearIdentityInfo } from '@driftt/web-auth'
import { Avatar } from '@driftt/tide-core-legacy'
import { Div, P, Icon } from '@driftt/tide-core-legacy'
import { LOGIN_APP_URL } from 'constants/ResourcesConstants'
import './style.styl'

class OrgSwitcherSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      displayableIdentities: getDisplayableIdentities(),
      canScrollUp: false,
      canScrollDown: getDisplayableIdentities().length >= 3
    }
    this.setListRef = element => this.listRef = element
  }

  switchOrg = (token) => {
    window.analytics && window.analytics.track('Org Switched', { })
    setAccessToken({ token })
    window.location.replace('/')
  }

  clearOrgOption = (token) => {
    clearIdentityInfo(token)
    this.setState({ displayableIdentities: getDisplayableIdentities() }, () => {
      this.onScroll() //recompute if we have to show scroll arrows
      this.props.onChange()
    })
  }

  renderOrgOption = (identity) => (
    <Div key={identity.email} className="org-switcher-option">
      <Div className="org-switcher-avatar-container">
        <Avatar user={identity} />
      </Div>
      <Div className="org-switcher-info" onClick={ () => this.switchOrg(identity.token) }>
        <P className="org-switcher-user-name org-switcher-user-identifier">{ identity.name }</P>
        <P className="org-switcher-user-identifier">{ identity.email }</P>
      </Div>
      <Div className="org-switcher-remove-account-container" key={identity.token} onClick={() => this.clearOrgOption(identity.token)} >
        <Icon className="org-switcher-remove-account" name="close" width={12} />
      </Div>
    </Div>
  )

  renderAddAccountOption = () => (
    <Div className="org-switcher-option">
      <Div className="org-switcher-avatar-container org-switcher-plus-sign-container">
        <Icon width={25} height={25} name="plus" />
      </Div>
      <Div className="org-switcher-info" onClick={ () => document.location = LOGIN_APP_URL }>
        <P className="org-switcher-user-name org-switcher-user-identifier">Add account</P>
        <P className="org-switcher-user-identifier">Log in as another user</P>
      </Div>
    </Div>
  )

  renderScrollIndicator = iconName => {
    const { canScrollUp, canScrollDown } = this.state
    const isUpArrow = iconName === "chevron-up"

    const scroll = (direction) => {
      try {
        this.listRef.scrollBy(0, 150 * direction) //3 options per page, 50px per option
      } catch(e) {
        console.error(e) //scrollBy doesn't work on Edge
      }
    }

    return <Div className={classnames(
      'org-switcher-scroll-indicator',
      iconName,
      { 'canScroll': (isUpArrow && canScrollUp) || (!isUpArrow && canScrollDown) }
    )} onClick={ () => scroll(isUpArrow ? -1 : 1) }>
      <Icon name={iconName} height="10px" width="10px"/>
    </Div>
  }

  onScroll = () => {
    const { displayableIdentities } = this.state
    const maxScrollTop = (50 * displayableIdentities.length) + 50 - this.listRef.offsetHeight
    // = combined height of list items plus height of add account option minus height of the list view

    this.setState({
      canScrollUp: this.listRef.scrollTop > 0,
      canScrollDown: this.listRef.scrollTop < maxScrollTop
    })
  }

  render() {
    const { displayableIdentities } = this.state
    return (
      <Div>
        { this.renderScrollIndicator("chevron-up") }
        <div className="org-switcher-list-container" ref={this.setListRef} onScroll={this.onScroll}>
          { displayableIdentities.map(this.renderOrgOption) }
          { this.renderAddAccountOption() }
        </div>
        { this.renderScrollIndicator("chevron-down") }
      </Div>
    )
  }
}

export default OrgSwitcherSection


// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/Popover/OrgSwitcherSection/component.js